import { AccAnchor } from "@components/base/AccAnchor";
import React from "react";
import slugify from "slugify";

type Heading = {
  value: string;
  depth: number;
};

export default ({ headings }: { headings: Heading[] }) => (
  <ul className={"m-0"}>
    {headings
      .filter(heading => heading.depth !== 1)
      .map(heading => {
        const isSubHeader = heading.depth > 2;
        return (
          <AccAnchor
            className={`mb-0.5 flex cursor-pointer ${
              isSubHeader ? "text-xs" : "text-sm"
            }`}
            key={heading.value}
            style={{ transform: `translateX(${(heading.depth - 2) * 30}px)` }}
            onClick={() => {
              /** Scroll to title */
              if (document) {
                const id = `#${slugify(heading.value, {
                  strict: true,
                  lower: true,
                })}`;
                document?.querySelector(id)?.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                });
              }
            }}
          >
            {isSubHeader ? "- " + heading.value : heading.value}
          </AccAnchor>
        );
      })}
  </ul>
);
